import { IntegrationStepLogsTable } from "components/Tables/IntegrationStepLogsTable/IntegrationStepLogsTable";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getLogHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/log/_layout/api-old/")({
    component: ApiLogsPage,
    staticData: {
        permissions: [PermissionEnum.ApiLogsView],
        showInSideMenu: false,
        label: "pages.log.api-old.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.log.api-old.title"),
        };
    },
});

function ApiLogsPage() {
    return (
        <TenantPage headerNavigationItems={getLogHeaderItems}>
            <IntegrationStepLogsTable />
        </TenantPage>
    );
}
